import Icon from './Icon';
import { useBranding } from '../branding/BrandingProvider';

/** The logo (or the default bolt icon) shown beside the CRM name. */
export default function BrandMark({ style }) {
  const { logoUrl, name } = useBranding();
  return logoUrl ? (
    <img className="brand-logo" src={logoUrl} alt={`${name} logo`} />
  ) : (
    <span className="brand-mark" style={style}>
      <Icon name="bolt" />
    </span>
  );
}
